import { Language } from "../types";

export const languages: Language[] = [
  {
    name: "English",
    level: "fluent",
  },
  {
    name: "French",
    level: "native",
  },
];
